import { OnChanges, SimpleChanges } from '@angular/core';
import { Product } from '../../models/product.model';
import { AnalyticsUtilsService } from '../../shared/analytics-utils.service';
var ProductLegendsComponent = /** @class */ (function () {
    function ProductLegendsComponent(analytics) {
        this.analytics = analytics;
        this.nameCont = "";
        /** TEXT ANIMATION CONTROL **/
        this.animationText = false;
        /** WEB PAGE **/
        this.animationStops = false;
        this.animationLanguage = false;
        this.animationSchedule = false;
        this.animationFree = false;
        this.animationVoucher = false;
        this.stateMiddle = 0;
        this.state2Middle = 0;
        /** MIDDLE ICONS HELPERS **/
        this.animationLeftDissapear = false;
        this.animationLeft2Dissapear = false;
        this.animationLeft3Dissapear = false;
        this.animationRightDissapear = false;
        this.animationRight2Dissapear = false;
        this.animationRight3Dissapear = false;
        /** MOBILE **/
        this.animationOnlyRoutes = false;
        this.animationOnlyStops = false;
        this.animationOnlySchedule = false;
        this.animationOnlyLanguages = false;
        this.animationOnlyFree = false;
        this.animationOnlyVoucher = false;
        this.listOfRoutes = [];
    }
    ProductLegendsComponent.prototype.ngOnChanges = function (changes) {
        if (this.product != null && this.product.hopOnHopOff) {
            var init = this.product.bestRoute.bestScheduleInit;
            var end = this.product.bestRoute.bestScheduleEnd;
            this.product.bestRoute.bestScheduleInit = new Date("01/01/1970 " + init);
            this.product.bestRoute.bestScheduleEnd = new Date("01/01/1970 " + end);
            this.createRoutes(this.product);
            this.createMainStops(this.product);
        }
        else if (this.product != null && !this.product.hopOnHopOff && this.product.bestRoute.duration != null) {
            this.time = this.product.bestRoute.duration; // Duration always arrives in 'minutes' 
            var type = this.product.bestRoute.durationType.toUpperCase();
            this.product.bestRoute.durationType = type;
            if (type === "HOUR") {
                this.time /= 60;
            }
            else if (type === "DAY") {
                this.time /= 60 * 24;
            }
        }
    };
    Object.defineProperty(ProductLegendsComponent.prototype, "stateText", {
        get: function () {
            return this.animationText ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateStops", {
        get: function () {
            return this.animationStops ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateVoucher", {
        get: function () {
            return this.animationVoucher ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateLanguage", {
        get: function () {
            return this.animationLanguage ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateFree", {
        get: function () {
            return this.animationFree ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateSchedule", {
        get: function () {
            return this.animationSchedule ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateMiddleDissapear", {
        get: function () {
            if (this.stateMiddle == 1) {
                return 'left';
            }
            else if (this.stateMiddle == 2) {
                return 'right';
            }
            else {
                return 'normal';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateMiddle2Dissapear", {
        get: function () {
            if (this.state2Middle == 1) {
                return 'left';
            }
            else if (this.state2Middle == 2) {
                return 'right';
            }
            else {
                return 'normal';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateLeftDissapear", {
        get: function () {
            return this.animationLeftDissapear ? 'transition' : 'normal';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateLeft2Dissapear", {
        get: function () {
            return this.animationLeft2Dissapear ? 'transition' : 'normal';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateLeft3Dissapear", {
        get: function () {
            return this.animationLeft3Dissapear ? 'transition' : 'normal';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateRightDissapear", {
        get: function () {
            return this.animationRightDissapear ? 'transition' : 'normal';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateRight2Dissapear", {
        get: function () {
            return this.animationRight2Dissapear ? 'transition' : 'normal';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateRight3Dissapear", {
        get: function () {
            return this.animationRight3Dissapear ? 'transition' : 'normal';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateOnlyRoutes", {
        get: function () {
            return this.animationOnlyRoutes ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateOnlyStops", {
        get: function () {
            return this.animationOnlyStops ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateOnlyVoucher", {
        get: function () {
            return this.animationOnlyVoucher ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateOnlySchedule", {
        get: function () {
            return this.animationOnlySchedule ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateOnlyLanguages", {
        get: function () {
            return this.animationOnlyLanguages ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductLegendsComponent.prototype, "stateOnlyFree", {
        get: function () {
            return this.animationOnlyFree ? 'back' : 'move';
        },
        enumerable: true,
        configurable: true
    });
    ProductLegendsComponent.prototype.startAnimation = function (nameID) {
        this.clickOnLegendIcon();
        if (nameID == 'languages') {
            this.animationLanguage = !this.animationLanguage;
            this.animationLeftDissapear = !this.animationLeftDissapear;
            this.animationRight2Dissapear = !this.animationRight2Dissapear;
            this.stateMiddle == 0 ? this.stateMiddle = 1 : this.stateMiddle = 0;
            this.state2Middle == 0 ? this.state2Middle = 1 : this.state2Middle = 0;
            this.nameCont = nameID;
            this.animationText = !this.animationText;
        }
        else if (nameID == 'routes') {
            this.animationRightDissapear = !this.animationRightDissapear;
            this.animationLeft2Dissapear = !this.animationLeft2Dissapear;
            this.stateMiddle == 0 ? this.stateMiddle = 1 : this.stateMiddle = 0;
            this.state2Middle == 0 ? this.state2Middle = 2 : this.state2Middle = 0;
            this.nameCont = nameID;
            this.animationText = !this.animationText;
        }
        else if (nameID == "schedule") {
            this.animationSchedule = !this.animationSchedule;
            this.animationLeftDissapear = !this.animationLeftDissapear;
            this.animationRightDissapear = !this.animationRightDissapear;
            this.stateMiddle != 1 ? this.stateMiddle = 1 : this.stateMiddle = 0;
            this.nameCont = 'routes';
            this.animationText = !this.animationText;
        }
        else if (nameID == 'stops') {
            this.animationStops = !this.animationStops;
            this.animationLeft3Dissapear = !this.animationLeft3Dissapear;
            this.animationRightDissapear = !this.animationRightDissapear;
            this.stateMiddle == 0 ? this.stateMiddle = 1 : this.stateMiddle = 0;
            this.state2Middle == 0 ? this.state2Middle = 2 : this.state2Middle = 0;
            this.nameCont = nameID;
            this.animationText = !this.animationText;
        }
        else if (nameID == 'free') {
            this.animationFree = !this.animationFree;
            this.animationRight3Dissapear = !this.animationRight3Dissapear;
            this.animationLeftDissapear = !this.animationLeftDissapear;
            this.stateMiddle == 0 ? this.stateMiddle = 1 : this.stateMiddle = 0;
            this.state2Middle == 0 ? this.state2Middle = 1 : this.state2Middle = 0;
            this.nameCont = nameID;
            this.animationText = !this.animationText;
        }
        else if (nameID == 'voucher') {
            this.animationVoucher = !this.animationVoucher;
            this.animationLeftDissapear = !this.animationLeftDissapear;
            this.animationRightDissapear = !this.animationRightDissapear;
            this.state2Middle == 0 ? this.state2Middle = 1 : this.state2Middle = 0;
            this.nameCont = nameID;
            this.animationText = !this.animationText;
        }
    };
    ProductLegendsComponent.prototype.startAnimationMobile = function (nameID) {
        this.clickOnLegendIcon();
        if (nameID == 'schedule') {
            this.animationSchedule = !this.animationSchedule;
            this.animationOnlyLanguages = !this.animationOnlyLanguages;
            this.animationOnlyFree = !this.animationOnlyFree;
            this.animationLeftDissapear = !this.animationLeftDissapear;
            this.nameCont = 'route';
            this.animationText = !this.animationText;
        }
        else if (nameID == 'route') {
            this.animationOnlyStops = !this.animationOnlyStops;
            this.animationOnlyVoucher = !this.animationOnlyVoucher;
            this.animationRightDissapear = !this.animationRightDissapear;
            this.nameCont = nameID;
            this.animationText = !this.animationText;
        }
        else if (nameID == 'languages') {
            this.animationLanguage = !this.animationLanguage;
            this.animationOnlySchedule = !this.animationOnlySchedule;
            this.animationOnlyFree = !this.animationOnlyFree;
            this.animationLeftDissapear = !this.animationLeftDissapear;
            this.nameCont = nameID;
            this.animationText = !this.animationText;
        }
        else if (nameID == 'voucher') {
            this.animationVoucher = !this.animationVoucher;
            this.animationOnlyStops = !this.animationOnlyStops;
            this.animationOnlyRoutes = !this.animationOnlyRoutes;
            this.animationRightDissapear = !this.animationRightDissapear;
            this.nameCont = nameID;
            this.animationText = !this.animationText;
        }
        else if (nameID == 'free') {
            this.animationFree = !this.animationFree;
            this.animationOnlySchedule = !this.animationOnlySchedule;
            this.animationOnlyLanguages = !this.animationOnlyLanguages;
            this.animationLeftDissapear = !this.animationLeftDissapear;
            this.nameCont = nameID;
            this.animationText = !this.animationText;
        }
        else {
            this.animationStops = !this.animationStops;
            this.animationOnlyVoucher = !this.animationOnlyVoucher;
            this.animationOnlyRoutes = !this.animationOnlyRoutes;
            this.animationRightDissapear = !this.animationRightDissapear;
            this.nameCont = nameID;
            this.animationText = !this.animationText;
        }
    };
    ProductLegendsComponent.prototype.clickOnLegendIcon = function () {
        // this.analytics.click_on_legendIcon();
    };
    ProductLegendsComponent.prototype.createRoutes = function (product) {
        var _this = this;
        this.listOfRoutes = [];
        product.routes.map(function (route) {
            _this.listOfRoutes.push(route);
        });
    };
    ProductLegendsComponent.prototype.createMainStops = function (product) {
        var _this = this;
        this.mainStops = [];
        var cache = {};
        if (product.routes != null) {
            product.routes.map(function (route) {
                route.stoppingPlaces.map(function (stop) {
                    if (stop.image && !cache[stop.id]) {
                        var _main = {};
                        _main['routeName'] = route.name;
                        _main['number'] = stop.number;
                        _main['name'] = stop.name;
                        _main['imageURL'] = stop.image;
                        _main['placeOrder'] = stop.placeOrder;
                        _this.mainStops.push(_main);
                        cache[stop.id] = true;
                    }
                });
            });
        }
    };
    return ProductLegendsComponent;
}());
export { ProductLegendsComponent };
